module.exports = __webpack_public_path__ + "img/EXTERIOR-IGNIS-2.acccc5b5.jpg";